import { Box } from '@chakra-ui/react'
import NewPatForm from './components/NewPatForm'
import { useEffect, useState } from 'react'
import { getOpenLanguages } from 'src/view-models/Languages'
import Loading from 'src/components/loading/Loading'
import { useAppDispatch } from 'src/redux/hooks'

const NewPatient = () => {
  const dispatch = useAppDispatch()
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    const fetchLanguages = async () => {
      await getOpenLanguages(dispatch)
      setIsLoading(false)
    }
    fetchLanguages()
  }, [])

  if (isLoading) {
    return <Loading />
  }

  return (
    <Box px={4} py={2} rounded={4}>
      <Box backgroundColor='white' p={8} boxShadow='md' >
        <NewPatForm />
      </Box>
    </Box>
  )
}

export default NewPatient